import styled from 'styled-components'
import { AiFillCaretLeft, AiFillCaretRight } from 'react-icons/ai'

export const LeftIcon = styled(AiFillCaretLeft)`
  width: 40px;
  height: 40px;
  cursor: pointer;
  user-select: none;

  transition: transform 0.2s;

  &:hover {
    transform: scale(1.2);
  }
`
export const RightIcon = styled(AiFillCaretRight)`
  width: 40px;
  height: 40px;
  cursor: pointer;
  user-select: none;

  transition: transform 0.2s;

  &:hover {
    transform: scale(1.2);
  }
`
